// The one list of admin accounts. The admin pages (AdminContext,
// AdminProtectedRoute), admin-operations and send-welcome-email all read it,
// so adding an admin is a single edit here plus a function redeploy.
// Import-free so Deno and Vite both load it.

export const ADMIN_EMAILS: readonly string[] = [
  'studio@faajistudios.com',
  'tobyogunlowo@gmail.com',
];

export function isAdminEmail(email: string | null | undefined): boolean {
  if (!email) return false;
  return ADMIN_EMAILS.includes(email.trim().toLowerCase());
}
